import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { BrowserView } from 'components/DeviceDetect'

const CategoryPageSkeleton = ({ showTiles = false }) => {
  return (
    <>
      {/* Breadcrumb skeleton */}
      <div className="mb-6">
        <BrowserView>
          <div className="flex items-center gap-2">
            <Skeleton
              width={60}
              height={16}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-sm"
            />
            <Skeleton
              width={8}
              height={16}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-sm"
            />
            <Skeleton
              width={90}
              height={16}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-sm"
            />
            <Skeleton
              width={8}
              height={16}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-sm"
            />
            <Skeleton
              width={120}
              height={16}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-sm"
            />
          </div>
        </BrowserView>
      </div>

      {/* Category tiles skeleton - only show if showTiles is true */}
      {showTiles && (
        <div className="mb-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {Array(8)
              .fill()
              .map((_, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl overflow-hidden shadow-md border border-[#ededed] p-4 transition-all duration-300 hover:border-gray-300 hover:shadow-lg"
                >
                  <Skeleton
                    height={120}
                    baseColor="#f8fafc"
                    highlightColor="#e2e8f0"
                    className="!rounded-lg mb-3"
                  />
                  <Skeleton
                    height={16}
                    width="80%"
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="!rounded-sm"
                  />
                </div>
              ))}
          </div>
        </div>
      )}

      {/* Section title skeleton */}
      <div className="mb-6">
        <Skeleton
          height={32}
          width="30%"
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
      </div>

      {/* Filter and sorting skeleton - Desktop */}
      <BrowserView>
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-4">
            <Skeleton
              width={120}
              height={36}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
            <Skeleton
              width={100}
              height={36}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
          </div>
          <Skeleton
            width={200}
            height={20}
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
        </div>
      </BrowserView>

      {/* Products grid skeleton */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-8">
        {Array(20)
          .fill()
          .map((_, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md border-t-2 border-[#f9fafb] mt-10 transition-all duration-300 hover:shadow-lg"
            >
              <div className="relative h-[140px] md:h-[180px]">
                <Skeleton
                  height="100%"
                  baseColor="#f8fafc"
                  highlightColor="#e2e8f0"
                />
              </div>
              <div className="p-3 md:p-5">
                <Skeleton
                  height={16}
                  width="90%"
                  baseColor="#f1f5f9"
                  highlightColor="#e2e8f0"
                  className="mb-2 !rounded-sm"
                />
                <Skeleton
                  height={16}
                  width="70%"
                  baseColor="#f1f5f9"
                  highlightColor="#e2e8f0"
                  className="mb-3 !rounded-sm"
                />
                <Skeleton
                  height={20}
                  width="60%"
                  baseColor="#f1f5f9"
                  highlightColor="#e2e8f0"
                  className="!rounded-sm"
                />
              </div>
            </div>
          ))}
      </div>

      {/* Pagination skeleton */}
      <div className="flex justify-center items-center gap-2 mt-8">
        {Array(5)
          .fill()
          .map((_, index) => (
            <Skeleton
              key={index}
              width={40}
              height={40}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
          ))}
      </div>
    </>
  )
}

export default CategoryPageSkeleton
